import templateUrl from "emun.order/order-details.htm";
import controller from "emun.order/order-details.controller";
import "emun.order/order-details.scss";

export default {
  bindings: {
    orderId: "@",
    mode: "<",
    openedit: "<",
  },
  require: {
    container: "^?orderContainer",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
